import { makeStyles } from 'tss-react/mui'
import { Instance as TinyColor } from 'tinycolor2'

const useStyles = makeStyles<{color: TinyColor, thumbnailColor: TinyColor}>()((theme, params) => ({
    colorSpace: {
        flexGrow: 1,
        borderRadius: '2px',
        padding: 0,
        width: '150px',
        height: '150px',
        background: params.color.clone().toRgbString(),
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
            content: '\"\"',
            position: 'absolute',
            height: '100%',
            width: '100%',
            top: 0,
            left: 0,
            zIndex: 1,
            background: 'linear-gradient(90deg,#fff,transparent)'
        },
        '&::after': {
            content: '\"\"',
            position: 'absolute',
            height: '100%',
            width: '100%',
            top: 0,
            left: 0,
            zIndex: 2,
            background: 'linear-gradient(0deg,#000,transparent)'
        }
    },
    colorPointer: {
        position: 'absolute',
        height: '14px',
        width: '14px',
        borderRadius: '50%',
        border: "2px solid #fff",
        transform: 'translate(-7px, -7px)',
        zIndex: 3
    },
    hueSliderContainer: {
        width: '28px',
        height: '150px',
        display: 'flex',
        justifyContent: 'center',
    },
    thumbnail: {
        height: '23px',
        width: '23px',
        minWidth: '23px',
        borderRadius: '3px',
        padding: '3px',
        background: 'transparent',
        boxSizing: 'border-box' as const,
        border: `1px solid ${theme.palette.divider}`,
        flexShrink: 0,
    },
    thumbnailInner: {
        height: '100%',
        width: '100%',
        borderRadius: '2px',
        background: params.thumbnailColor.toRgbString(),
    },
    colorDisplay: {
        fontSize: '0.75rem',
        border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'}`,
        borderRadius: '4px',
        padding: theme.spacing(0, 0.5),
        background: 'transparent',
        color: theme.palette.text.primary,
        outline: 'none',
        width: '100%',
        fontFamily: 'inherit',
        '&:focus': {
            borderColor: theme.palette.primary.main,
            borderWidth: '2px',
        }
    },
    divider: {
        margin: theme.spacing(0.75, 0)
    },
}))

export default useStyles